import { useEffect, useState } from 'react';
import Dialog from '@/components/Dialog';
import { fetchTermsAndConditions } from '@/services/global/global';
import { TermAndCondition } from '@/graphql/generated/graphql';
import Button from '../Button';
import { convert } from '@/utils/mark-to-html';

function DialogTermsAndServices({ open, setOpen }: { open?: boolean; setOpen: React.Dispatch<boolean> }) {
  const [termsAndConditions, setTermsAndConditions] = useState<TermAndCondition | null>(null);
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    const fetchFooterData = async () => {
      const result = await fetchTermsAndConditions();
      setTermsAndConditions(result.termsAndConditions as TermAndCondition);
    };

    fetchFooterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!termsAndConditions?.content) {
      return;
    }

    async function process() {
      const converted = await convert(termsAndConditions!.content!);
      setHtml(converted);
    }
    process();
  }, [termsAndConditions, termsAndConditions?.content]);

  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={termsAndConditions?.title || 'Terms and conditions'}
      body={
        <>
          <div
            className="text-justify text-sh-xs"
            dangerouslySetInnerHTML={{
              __html: html || '',
            }}></div>
          <Button theme="solid" className="mt-5" onClick={() => setOpen(false)}>
            Close
          </Button>
        </>
      }
    />
  );
}

export default DialogTermsAndServices;
